import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { store } from 'Store';
import { useDispatch } from "react-redux";
import { http } from "Utils/http";
import { Row, Col, Card, Stack } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { submitDeleteVendorAuth } from "../VendorAxiosFuncs";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import ConfirmDeleteVendorPopup from "./Component/ConfirmDeleteVendorPopup";

const ViewVendorAuthorization = () => {

  const location = useLocation();
  const dispatch = useDispatch();
  const loginState = store.getState().loginInfo;
  const vaId = location.state.id;
  const token = "Bearer " + loginState.token;
  const [vendorAuthInfo, setVendorAuthInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  // get vendor auth info data
  const getVendorAuthorizationInfo = async () => {

    const url = "/api/organization/vendor-authorization/view";
    const body = { "vaId": vaId };

    const res = await http.post(url, body, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    }).then((res) => {
      if (res.status != 1) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: res.globalErrorMessageList[0],
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        });
      }
      else {
        var d = res.data;
        //console.log("print out vendor auth info", res.data);
        setVendorAuthInfo(res.data);

      }
      setIsLoading(false);

    }).catch((error) => {
      //console.log("Error caught while loading data: " + error);
      setIsLoading(false);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  useEffect(() => {
    getVendorAuthorizationInfo();
    window.scrollTo(0, 0);
  }, []);

  const handleDateFormat = (time) => {

    if (time == null) {
      return;
    }

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
      </div>
    )
  }

  const handleBack = () => {
    navigate("/manage/authorization");
  }

  const handleDelete = async () => {
    const res = submitDeleteVendorAuth(token, vendorAuthInfo.psoOrganizationId, vaId)
      .then((res) => {
        if (res !== null && res !== undefined) {
          //console.log("submitDeleteVendorAuth", res);
          var statusCode = res.data.status;
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: true
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              //console.log("submitDeleteVendorAuth success", res);
              setGlobalSuccessStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: "Success!",
                  msg: res.data.message,
                  showContactHelp: false
                },
                redirect: {
                  redirect: true,
                  redirectFirst: true,
                  path: "/manage/authorization",
                  data: {}
                }
              });
              break;

          }
        }
        //console.log(res);
      }).catch((error) => {
        //console.log("Error caught while loading data: " + error);
        setIsLoading(false);
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      })
  }

  const handleShowDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }


  return (
    <Row>{isLoading == false ?
      <>
        <ConfirmDeleteVendorPopup
          show={showDeletePopup}
          handleClose={handleCloseDeletePopup}
          handleDelete={handleDelete}>
        </ConfirmDeleteVendorPopup>
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 id="mainContent" className="header1 text-start mb-3 blue bold">View Vendor Authorization</h1>
              <h2 className="text-start mb-2 form-title">Vendor Authorization</h2>
              <br />
              <Row className="mb-1">
                <Col lg={2}>
                  <span className="name form-label-style">PSO Organization</span>
                </Col>
                <Col lg={6}>
                  {vendorAuthInfo?.psoId}&nbsp;&ndash;&nbsp;{vendorAuthInfo?.psoName}
                </Col>
              </Row>
              <br />
              <Row className="mb-1">
                <Col lg={2}>
                  <span className="name form-label-style">Vendor</span>
                </Col>
                <Col lg={6}>
                  {vendorAuthInfo?.vendorId}&nbsp;&ndash;&nbsp;{vendorAuthInfo?.vendorName}
                </Col>
              </Row>
              <br />
              <Row className="mb-1">
                <Col lg={2}>
                  <span className="name form-label-style">Start Date</span>
                </Col>
                <Col lg={6}>
                  {handleDateFormat(vendorAuthInfo?.startDate)}
                </Col>
              </Row>
              <br />
              <Row className="mb-1">
                <Col lg={2}>
                  <span className="name form-label-style">End Date</span>
                </Col>
                <Col lg={6}>
                  {handleDateFormat(vendorAuthInfo?.endDate)}
                </Col>
              </Row>
              <Row className="mb-1">
                <Col lg={4}>
                  <Stack className="pt-3" direction="horizontal" gap={3}>
                    <TextButton
                      variant="normal"
                      onClick={handleShowDeletePopup}
                      content={"Delete"}
                    >
                    </TextButton>
                  </Stack>
                </Col>
                <Col>
                  <Stack className="pt-3 float-end" direction="horizontal" gap={3}>
                    {/* Back Button */}
                    <TextButton
                      variant="outline"
                      onClick={handleBack}
                      content={"Back"}
                    >
                    </TextButton>
                  </Stack>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </>
      : null}</Row>
  )
}

export default ViewVendorAuthorization;